import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home/Home.vue';
import Corporations from '@/views/corporations/Index.vue';
import CorporationNew from '@/views/corporations/New.vue';
import CorporationDetail from '@/views/corporations/Show.vue';
import CorporationEdit from '@/views/corporations/Edit.vue';
import CorporationConfirm from '@/views/corporations/Confirm.vue';
import CorporationChangePassword from '@/views/corporations/ChangePassword.vue';
import CorporationFrozen from '@/views/corporations/Frozen.vue';
import Brands from '@/views/brands/Index.vue';
import BrandNew from '@/views/brands/New.vue';
import BrandDetail from '@/views/brands/Show.vue';
import BrandEdit from '@/views/brands/Edit.vue';
import BrandConfirm from '@/views/brands/Confirm.vue';
import BrandChangePassword from '@/views/brands/ChangePassword.vue';
import BrandFrozen from '@/views/brands/Frozen.vue';
import Schools from '@/views/schools/Index.vue';
import SchoolNew from '@/views/schools/New.vue';
import SchoolDetail from '@/views/schools/Show.vue';
import SchoolEdit from '@/views/schools/Edit.vue';
import SchoolConfirm from '@/views/schools/Confirm.vue';
import SchoolChangePassword from '@/views/schools/ChangePassword.vue';
import SchoolFrozen from '@/views/schools/Frozen.vue';
import SchoolVideoViewings from '@/views/video_viewings/Index.vue';
import VideoViewingNew from '@/views/video_viewings/New.vue';
import VideoViewingConfirm from '@/views/video_viewings/Confirm.vue';
import VideoViewingPoleChangePassword from '@/views/video_viewings/ChangePassword.vue';
import Teachers from '@/views/teachers/Index.vue';
import TeacherNew from '@/views/teachers/New.vue';
import TeacherDetail from '@/views/teachers/Show.vue';
import TeacherEdit from '@/views/teachers/Edit.vue';
import TeacherConfirm from '@/views/teachers/Confirm.vue';
import TeacherChangePassword from '@/views/teachers/ChangePassword.vue';
import TeacherFrozen from '@/views/teachers/Frozen.vue';
import Classes from '@/views/tamai_classes/Index.vue';
import ClassNew from '@/views/tamai_classes/New.vue';
import ClassDetail from '@/views/tamai_classes/Show.vue';
import ClassEdit from '@/views/tamai_classes/Edit.vue';
import ClassConfirm from '@/views/tamai_classes/Confirm.vue';
import ClassFrozen from '@/views/tamai_classes/Frozen.vue';
import Courses from '@/views/courses/Index.vue';
import CourseNew from '@/views/courses/New.vue';
import CourseDetail from '@/views/courses/Show.vue';
import CourseEdit from '@/views/courses/Edit.vue';
import CourseConfirm from '@/views/courses/Confirm.vue';
import CourseFrozen from '@/views/courses/Frozen.vue';
import Students from '@/views/students/Index.vue';
import StudentNew from '@/views/students/New.vue';
import StudentDetail from '@/views/students/Show.vue';
import StudentEdit from '@/views/students/Edit.vue';
import StudentConfirm from '@/views/students/Confirm.vue';
import StudentHistory from '@/views/students/History.vue';
import StudentChangePassword from '@/views/students/ChangePassword.vue';
import StudentChangeAffiliation from '@/views/students/ChangeAffiliation.vue';
import StudentChangeAffiliationConfirm from '@/views/students/ChangeAffiliationConfirm.vue';
import StudentTrialRegistration from '@/views/students/TrialRegistration.vue';
import StudentImports from '@/views/students/imports/Index.vue';
import StudentImportGroupEdit from '@/views/students/imports/GroupEdit.vue';
import StudentImportConfirm from '@/views/students/imports/Confirm.vue';
import Frozen from '@/views/frozens/Index.vue';
import TrialCourseSetting from '@/views/settings/TrialCourseSetting.vue';
import TeacherProfileSetting from '@/views/settings/TeacherProfileSetting.vue';
import AskTeacher from '@/views/ask_teachers/Index.vue';
import AdvanceStudent from '@/views/advance_students/Index.vue';
import TestPreparationSelection from '@/views/test_preparations/Selection.vue';
import Notifications from '@/views/notifications/Index.vue';
import NotificationDetail from '@/views/notifications/Show.vue';
import NotificationEdit from '@/views/notifications/Edit.vue';
import Billings from '@/views/billings/Index.vue';
import ContactUs from '@/views/contact_us/Index.vue';
import Login from '@/views/login/Index.vue';
import LoginTeacherForm from '@/views/login/form/Teacher.vue';
import LoginCBSForm from '@/views/login/form/CBS.vue';
import TamaishikiLogin from '@/views/login/TamaishikiLogin.vue';
import Choice from '@/views/choices/Choice.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/corporation',
    name: 'corporation',
    component: Corporations,
  },
  {
    path: '/corporation/add',
    name: 'corporation-add',
    component: CorporationNew,
  },
  {
    path: '/corporation/:id',
    name: 'corporation-id-detail',
    component: CorporationDetail,
    props: true,
  },
  {
    path: '/corporation/:id/edit',
    name: 'corporation-id-edit',
    component: CorporationEdit,
    props: true,
  },
  {
    path: '/corporation/:id/confirm',
    name: 'corporation-id-confirm',
    component: CorporationConfirm,
    props: true,
  },
  {
    path: '/corporation/:id/change-password',
    name: 'corporation-id-change-password',
    component: CorporationChangePassword,
    props: true,
  },
  {
    path: '/corporation/:id/frozen',
    name: 'corporation-id-frozen',
    component: CorporationFrozen,
    props: true,
  },
  {
    path: '/corporation-detail',
    name: 'corporation-detail',
    component: CorporationDetail,
  },
  {
    path: '/corporation-change-password',
    name: 'corporation-change-password',
    component: CorporationChangePassword,
  },
  {
    path: '/corporation-confirm',
    name: 'corporation-confirm',
    component: CorporationConfirm,
  },
  {
    path: '/brand',
    name: 'brand',
    component: Brands,
  },
  {
    path: '/brand-add',
    name: 'brand-add',
    component: BrandNew,
  },
  {
    path: '/brand/:id',
    name: 'brand-id-detail',
    component: BrandDetail,
    props: true,
  },
  {
    path: '/brand/:id/edit',
    name: 'brand-id-edit',
    component: BrandEdit,
    props: true,
  },
  {
    path: '/brand/:id/confirm',
    name: 'brand-id-confirm',
    component: BrandConfirm,
    props: true,
  },
  {
    path: '/brand/:id/change-password',
    name: 'brand-id-change-password',
    component: BrandChangePassword,
    props: true,
  },
  {
    path: '/brand/:id/frozen',
    name: 'brand-id-frozen',
    component: BrandFrozen,
    props: true,
  },
  {
    path: '/brand-detail',
    name: 'brand-detail',
    component: BrandDetail,
  },
  {
    path: '/brand-confirm',
    name: 'brand-confirm',
    component: BrandConfirm,
  },
  {
    path: '/brand-change-password',
    name: 'brand-change-password',
    component: BrandChangePassword,
  },
  {
    path: '/school',
    name: 'school',
    component: Schools,
  },
  {
    path: '/school/add',
    name: 'school-add',
    component: SchoolNew,
  },
  {
    path: '/school/:id',
    name: 'school-id-detail',
    component: SchoolDetail,
    props: true,
  },
  {
    path: '/school/:id/edit',
    name: 'school-id-edit',
    component: SchoolEdit,
    props: true,
  },
  {
    path: '/school/:id/confirm',
    name: 'school-id-confirm',
    component: SchoolConfirm,
    props: true,
  },
  {
    path: '/school/:id/change-password',
    name: 'school-id-change-password',
    component: SchoolChangePassword,
    props: true,
  },
  {
    path: '/school/:id/video-viewing',
    name: 'school-id-video-viewing',
    component: SchoolVideoViewings,
    props: true,
  },
  {
    path: '/school/:id/frozen',
    name: 'school-id-frozen',
    component: SchoolFrozen,
    props: true,
  },
  {
    path: '/school-detail',
    name: 'school-detail',
    component: SchoolDetail,
  },
  {
    path: '/school-change-password',
    name: 'school-change-password',
    component: SchoolChangePassword,
  },
  {
    path: '/school-confirm',
    name: 'school-confirm',
    component: SchoolConfirm,
  },
  {
    path: '/video-viewing-add',
    name: 'video-viewing-add',
    component: VideoViewingNew,
  },
  {
    path: '/video-viewing-confirm',
    name: 'video-viewing-confirm',
    component: VideoViewingConfirm,
  },
  {
    path: '/video-viewing-pole/:id/change-password',
    name: 'video-viewing-pole-id-change-password',
    component: VideoViewingPoleChangePassword,
    props: true,
  },
  {
    path: '/teacher',
    name: 'teacher',
    component: Teachers,
  },
  {
    path: '/teacher/:id',
    name: 'teacher-id-detail',
    component: TeacherDetail,
    props: true,
  },
  {
    path: '/teacher/:id/edit',
    name: 'teacher-id-edit',
    component: TeacherEdit,
    props: true,
  },
  {
    path: '/teacher/:id/confirm',
    name: 'teacher-id-confirm',
    component: TeacherConfirm,
    props: true,
  },
  {
    path: '/teacher/:id/change-password',
    name: 'teacher-id-change-password',
    component: TeacherChangePassword,
    props: true,
  },
  {
    path: '/teacher/:id/frozen',
    name: 'teacher-id-frozen',
    component: TeacherFrozen,
    props: true,
  },
  {
    path: '/teacher-detail',
    name: 'teacher-detail',
    component: TeacherDetail,
  },
  {
    path: '/teacher-change-password',
    name: 'teacher-change-password',
    component: TeacherChangePassword,
  },
  {
    path: '/teacher-confirm',
    name: 'teacher-confirm',
    component: TeacherConfirm,
  },
  {
    path: '/teacher-add',
    name: 'teacher-add',
    component: TeacherNew,
  },
  {
    path: '/class',
    name: 'class',
    component: Classes,
  },
  {
    path: '/class-add',
    name: 'class-add',
    component: ClassNew,
  },
  {
    path: '/class/:id',
    name: 'class-id-detail',
    component: ClassDetail,
    props: true,
  },
  {
    path: '/class/:id/edit',
    name: 'class-id-edit',
    component: ClassEdit,
    props: true,
  },
  {
    path: '/class/:id/confirm',
    name: 'class-id-confirm',
    component: ClassConfirm,
    props: true,
  },
  {
    path: '/class/:id/frozen',
    name: 'class-id-frozen',
    component: ClassFrozen,
    props: true,
  },
  {
    path: '/class-confirm',
    name: 'class-confirm',
    component: ClassConfirm,
  },
  {
    path: '/course',
    name: 'course',
    component: Courses,
  },
  {
    path: '/course-add',
    name: 'course-add',
    component: CourseNew,
  },
  {
    path: '/course/:id',
    name: 'course-id-detail',
    component: CourseDetail,
    props: true,
  },
  {
    path: '/course/:id/edit',
    name: 'course-id-edit',
    component: CourseEdit,
    props: true,
  },
  {
    path: '/course/:id/confirm',
    name: 'course-id-confirm',
    component: CourseConfirm,
    props: true,
  },
  {
    path: '/course/:id/frozen',
    name: 'course-id-frozen',
    component: CourseFrozen,
    props: true,
  },
  {
    path: '/course-confirm',
    name: 'course-confirm',
    component: CourseConfirm,
  },
  {
    path: '/student',
    name: 'student',
    component: Students,
  },
  {
    path: '/student-add',
    name: 'student-add',
    component: StudentNew,
  },
  {
    path: '/student/:id',
    name: 'student-id-detail',
    component: StudentDetail,
    props: true,
  },
  {
    path: '/student/:id/edit',
    name: 'student-id-edit',
    component: StudentEdit,
    props: true,
  },
  {
    path: '/student/:id/confirm',
    name: 'student-id-confirm',
    component: StudentConfirm,
    props: true,
  },
  {
    path: '/student/:id/change-password',
    name: 'student-id-change-password',
    component: StudentChangePassword,
    props: true,
  },
  {
    path: '/student-detail',
    name: 'student-detail',
    component: StudentDetail,
  },
  {
    path: '/student-confirm',
    name: 'student-confirm',
    component: StudentConfirm,
  },
  {
    path: '/student-change-password',
    name: 'student-change-password',
    component: StudentChangePassword,
  },
  {
    path: '/student/:id/student-history',
    name: 'student-id-history',
    component: StudentHistory,
    props: true,
  },
  {
    path: '/student-change-affiliation',
    name: 'student-change-affiliation',
    component: StudentChangeAffiliation,
  },
  {
    path: '/student-change-affiliation-confirm',
    name: 'student-change-affiliation-confirm',
    component: StudentChangeAffiliationConfirm,
  },
  {
    path: '/trial-student-registration',
    name: 'trial-student-registration',
    component: StudentTrialRegistration,
  },
  {
    path: '/student-import',
    name: 'student-import',
    component: StudentImports,
  },
  {
    path: '/student-import-edit',
    name: 'student-import-edit',
    component: StudentImportGroupEdit,
  },
  {
    path: '/student-import-confirm',
    name: 'student-import-confirm',
    component: StudentImportConfirm,
  },
  {
    path: '/frozen',
    name: 'frozen',
    component: Frozen,
  },
  {
    path: '/trial-course-setting',
    name: 'trial-course-setting',
    component: TrialCourseSetting,
  },
  {
    path: '/teacher-profile-setting',
    name: 'teacher-profile-setting',
    component: TeacherProfileSetting,
  },
  {
    path: '/ask-teacher',
    name: 'ask-teacher',
    component: AskTeacher,
  },
  {
    path: '/advance-student',
    name: 'advance-student',
    component: AdvanceStudent,
  },
  {
    path: '/test-preparation-print',
    name: 'test-preparation-print',
    component: TestPreparationSelection,
  },
  {
    path: '/notification',
    name: 'notification',
    component: Notifications,
  },
  {
    path: '/notification/:id',
    name: 'notification-id-detail',
    component: NotificationDetail,
    props: true,
  },
  {
    path: '/notification/:id/edit',
    name: 'notification-id-edit',
    component: NotificationEdit,
    props: true,
  },
  {
    path: '/notification-add',
    name: 'notification-add',
    component: NotificationEdit,
  },
  {
    path: '/billing',
    name: 'billing',
    component: Billings,
  },
  {
    path: '/billing/corporation/:corporationId/:preFilteredMonth',
    name: 'billing-corporation-id',
    component: Billings,
    props: true,
  },
  {
    path: '/billing/brand/:brandId/:preFilteredMonth',
    name: 'billing-brand-id',
    component: Billings,
    props: true,
  },
  {
    path: '/billing/school/:schoolId/:preFilteredMonth',
    name: 'billing-school-id',
    component: Billings,
    props: true,
  },
  {
    path: '/contact-us',
    name: 'contact_us',
    component: ContactUs,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/login/teacher',
    name: 'login_teacher',
    component: LoginTeacherForm,
  },
  {
    path: '/login/cbs',
    name: 'login_corporation_brand_school',
    component: LoginCBSForm,
  },
  {
    path: '/tamaishiki_private',
    name: 'tamaishiki_private',
    component: TamaishikiLogin,
  },
  {
    path: '/choice/:resourceType',
    name: 'choice',
    component: Choice,
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
